import { useEffect, useState } from "react";

const PREFERS_REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

const usePrefersReducedMotion = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return undefined;
    }

    const mediaQueryList = window.matchMedia(PREFERS_REDUCED_MOTION_QUERY);
    const updatePreference = () => setPrefersReducedMotion(mediaQueryList.matches);

    updatePreference();

    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener("change", updatePreference);
      return () => mediaQueryList.removeEventListener("change", updatePreference);
    }

    mediaQueryList.addListener(updatePreference);
    return () => mediaQueryList.removeListener(updatePreference);
  }, []);

  return prefersReducedMotion;
};

export default usePrefersReducedMotion;
